document.addEventListener("DOMContentLoaded", function () {

  var addToCartBanner = document.getElementById('huratips-addtocart-sticky');

  if (addToCartBanner) {
  addToCartBanner.classList.add('visible')
      addToCartBanner.classList.remove('hidden')
  }

  
  var radioChoices = document.querySelectorAll(".product__selectors .radio__button");
  radioChoices.forEach(function (e, t) {
        e.addEventListener("click", function () {(
          document.querySelector(".select__fieldset").style.display = 0 === t ? "block" : "none"
        ),
        
          setTimeout(function () {
            let e2 = document.querySelectorAll(".product__price .product__price--regular");

            e2.forEach((ev) =>{
                document.querySelectorAll(".btn--submit .product__price--regular").forEach((ev2)=>{
                ev2.innerText = ev.innerText;
                })

              document.querySelectorAll('#huratips-addtocart-sticky select option').forEach((option) =>{
                if(option.dataset.price === ev.innerText){
                  option.selected = true;
                } else{
                  option.selected = false;
                }
              })
            })
          }, 100);
        });
    });

  var selectBar = document.querySelector('#huratips-addtocart-sticky select');

  if (selectBar) {
  selectBar.addEventListener('change',(e)=>{
    document.querySelectorAll('.btn--submit .product__price--regular').forEach((rp) =>{
      rp.innerText = selectBar.options[selectBar.selectedIndex].dataset.price
    })

    radioChoices.forEach((choice) =>{
      if(choice.querySelector('.variant_price strong').innerText === selectBar.options[selectBar.selectedIndex].dataset.price){
        choice.querySelector('input').checked = true;
      } else{
        choice.querySelector('input').checked = false;
      }
    })
  }) 
  }

    var e = document.querySelector(".product__block.standard__app + .product__block .product__subheading");

    if (document.querySelector(".product__block.standard__app")) {
      document.querySelector(".product__block.standard__app").appendChild(e); 
    }
});